import {UserConstants} from '../constants'

let initialState = {
    employees:[],
    changeManager:"",
    changeTeam:"",
    error:""
}
export const employeeList = (state=initialState, action) => {
    switch (action.type) {
        case UserConstants.GET_DETAILS_SUCCESS:
            return {...state, employees:action.payload};
        case UserConstants.GET_DETAILS_FAILURE:
            return {...state, error:action.payload};
        default:
            return state;
    }
};


let initialStateDetails = {
    employeeDetails:"",
    error:""
}
export const empDetails = (state=initialStateDetails, action) => {
    switch (action.type) {
        case UserConstants.PROFILE_DETAILS_SUCCESS:
            return {...state, employeeDetails:action.payload};
        case UserConstants.PROFILE_DETAILS_FAILURE:
            return {...state, error:action.payload};
        default:
            return state;
    }
};
let managerUpdateInitialState = {
    manager:[],
    error:""
}

export const managerUpdate_Reducer = (state=managerUpdateInitialState, action) => {
    switch (action.type) {
        case UserConstants.SET_MANAGER_SUCCESS:
            return {...state, manager:action.payload};
        case UserConstants.SET_MANAGER_FAILURE:
            return {...state, error:action.payload};
        default:
            return state;
    }
};

export const changeManager_Reducer = (state=initialState, action) => {
    switch (action.type) {
        case UserConstants.CHANGE_MANAGER_SUCCESS:
            return {...state, changeManager:action.payload};
        case UserConstants.CHANGE_MANAGER_FAILURE:
            return {...state, error:action.payload};
        default:
            return state;
    }
};

export const changeTeam_Reducer = (state=initialState, action) => {
    switch (action.type) {
        case UserConstants.CHANGE_TEAM_SUCCESS:
            return {...state, changeTeam:action.payload};
        case UserConstants.CHANGE_TEAM_FAILURE:
            return {...state, error:action.payload};
        default:
            return state;
    }
};